import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../components/Header";
import styles from './index.module.css';
import NotFound from "../components/NotFound";
import Footer from "../components/Footers";
import EntityAdminSidebar from "../components/Sidebar/EntityAdminSidebar";
import EntityAdminRoutes from "../routes/EntityAdminRoutes";
import EntityAdminHeader from "../components/Header/EntityAdminHeader";
import { useSelector } from "react-redux";

const EntityAdminLayout = () => {
    const entityVersion = useSelector(
        (state) => state.auth.entityVersion
    );

    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div key={entityVersion} className={styles.appContainer}>
            <EntityAdminSidebar isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar} />
            <div className={styles.main}>
                <EntityAdminHeader toggleSidebar={toggleSidebar} />
                <div className={styles.content}>
                    <Routes>
                        {EntityAdminRoutes.map((prop, key) => (
                            <Route path={prop.path} element={prop.element} key={key} />
                        ))}
                        <Route path="*" element={<div><NotFound /></div>} />
                    </Routes>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default EntityAdminLayout;
